import paidStyles from "../../pages/StudioProfile/PaidEquipmentModal.module.css";
import { paidCategoryHeading } from "../../pages/StudioProfile/paidEquipmentHelpers";
import { EquipmentBookingActions } from "./EquipmentBookingActions";
import modalClasses from "./BookingEquipmentDetailModal.module.css";

function stockLabel(n) {
    const x = typeof n === "number" ? n : parseInt(String(n), 10);
    if (!Number.isFinite(x) || x < 0) return null;
    return `${x} Stück`;
}

export function BookingEquipmentDetailModal({ item, counts, checked, onClose }) {
    if (!item) return null;

    const { equipmentItemId, name, price, image, description, maxCount, counted, categoryKey } = item;
    const stock = stockLabel(maxCount);
    const categoryLine = categoryKey ? paidCategoryHeading(categoryKey) : null;

    return (
        <div className={modalClasses.root}>
            <header className={modalClasses.headerMinimal}>
                <span className={modalClasses.headerSpacer} aria-hidden />
                <button type="button" className={paidStyles.closeBtn} onClick={onClose} aria-label="Schließen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M7.50947 8.5L0 0.990535L0.990535 0L8.5 7.50947L16.0095 0L17 0.990535L9.49054 8.5L17 16.0095L16.0095 17L8.5 9.49054L0.990535 17L0 16.0095L7.50947 8.5Z"
                            fill="#1F1F1F"
                        />
                    </svg>
                </button>
            </header>
            <div className={paidStyles.body}>
                <div className={paidStyles.detailTop}>
                    <div className={paidStyles.detailImageBox}>{image ? <img src={image} alt={name} /> : null}</div>
                    <div className={paidStyles.detailMeta}>
                        {categoryLine ? (
                            <p className={`${paidStyles.detailCategory} regularSmall`}>{categoryLine}</p>
                        ) : null}
                        <h2 className={`${paidStyles.detailTitle} titleSemibold3`}>{name}</h2>
                        <div className={paidStyles.priceRow}>
                            <p className={`${paidStyles.detailPrice} regularMiddle`}>{price}</p>
                            {stock ? <span className={`${paidStyles.detailStockPill} semiboldXxs`}>{stock}</span> : null}
                        </div>
                    </div>
                </div>
                {description ? (
                    <div className={paidStyles.descBlock}>
                        <h3 className={`${paidStyles.descHeading} semiboldMiddle`}>Beschreibung</h3>
                        <p className={`${paidStyles.descText} regularLarge`}>{description}</p>
                    </div>
                ) : null}
            </div>
            <footer className={modalClasses.modalFooter}>
                <EquipmentBookingActions
                    equipmentItemId={equipmentItemId}
                    name={name}
                    price={price}
                    maxCount={maxCount}
                    counted={counted}
                    counts={counts}
                    checked={checked}
                    layout="modal"
                />
            </footer>
        </div>
    );
}
